import React, { useEffect, useState } from 'react';
import PlayerHandler from '../players/MediaPlayerHandler';
import Modal from '../common/Modal';
import { Modal as AntdModal, notification } from 'antd';
import FullScreenModal from '../common/FullScreenModal';
import TransparentModal from '../common/TransparentModal';
import { useGetResourcesByIdMutation } from '../../api';
import { setCDNCookies } from '../../utils/cdnUtil';
import { UserPreference } from '../../config';
import getOS from '../../utils/getOS';
import getInstallationMode from '../../utils/getInstallationMode';
import { useDispatch, useSelector } from 'react-redux';
import store, { RootState } from '../../store';
import { useOpenBrowserMutation } from '../../api/open-browser';
import { trackEvent } from '../../segment';
import { getARIResourceUrl } from '../../helper';
import { setAndroidMediaPlayerOpen } from '../../features/androidMediaPlayer/androidMediaPlayerSlice';

interface AssetViewerProps {
    isOpen: boolean;
    onClose: () => void;
    type: string;
    resId: string;
    resPath: string;
    bookUri: string;
    bookId: string;
    pageNum?: string | number;
    unitId?: string;
    source?: string;
    resTitle?: string;
    resExtenstion?: string;
    bookPageNum?: number;
    visualPageNum?: number;
}

const AssetViewer: React.FC<AssetViewerProps> = ({
    isOpen,
    onClose,
    type,
    resId,
    resPath,
    bookUri,
    bookId,
    pageNum,
    resExtenstion,
    source,
    resTitle,
    bookPageNum,
    visualPageNum,
}) => {
    const currentPageNumber = useSelector(
        (state: RootState) => state.currentBook.currentPage
    );
    const user = useSelector((state: RootState) => state.auth.user);
    const userRole = user?.rolename ? user?.rolename : 'Teacher';
    const activeTab = useSelector((state: RootState) => state.toggle.activeTab);
    const [completeUrl, setCompleteUrl] = useState<string>('');
    const [resType, setResType] = useState<string>('');
    const resourceConfigLookup = useSelector(
        (state: RootState) => state.ResourceConfig.resourceConfigLookup
    );
    const isAndroidMediaPlayerOpen = useSelector(
        (state: RootState) => state.AndroidMediaPlayer.isOpen
    );
    const BuildrLabActivityModalInfo =
        resourceConfigLookup['Buildr Lab Activity']?.modal;
    const description = BuildrLabActivityModalInfo?.description;
    const product = useSelector((state: RootState) => state.product);
    const link =
        product === 'ActiveTeach'
            ? process.env.REACT_APP_SIDE_BAR_AT_URL
            : process.env.REACT_APP_SIDE_BAR_BUILDR_URL;
    const title = BuildrLabActivityModalInfo?.title;
    const showRedirectButton = BuildrLabActivityModalInfo?.showRedirectButton;
    const buttonText = BuildrLabActivityModalInfo?.buttonText;
    const [isPopupOpen, setIsPopupOpen] = useState(true);
    const [isModalOpen, setIsModalOpen] = useState(true);
    const [error, setError] = useState<string | null>(null);
    const installationPackage = useSelector(
        (state: RootState) =>
            state.SchoolInfo.data.installation_package?.INSTALLATION_MODE
    );
    const academicYearId = useSelector((state: RootState) => state.classSubjects.data.academicYearId)
    const handleOk = () => {
        setIsModalOpen(false);
        exitPlayer();
    };
    const token = useSelector((state: RootState) => state.auth.token);
    const school_id = store.getState().SchoolInfo.data.school.id;
    const [getResourcesById, { isLoading, isError }] =
        useGetResourcesByIdMutation();

    const os = getOS();
    const dispatch = useDispatch();

    useEffect(() => {
        if (error) {
            notification.error({
                message: 'Error',
                description: error,
                duration: 3,
            });
        }
    }, [error]);

    useEffect(() => {
        const extension = resPath?.split('.').pop()?.toLowerCase() || '';
        if (source != 'resource viewer') {
            trackEvent('click_resource', {
                res_id: resId,
                res_title: resTitle,
                res_extension: resExtenstion,
                source: source,
                page_num: pageNum,
                book_page_num: bookPageNum,
                visual_page_num: visualPageNum,
            });
        }
        const isARI = resPath.toLowerCase().indexOf('/ari/') > -1;
        if (isARI) {
            type = 'ARI';
        }
        if (!type) {
            if (extension === 'pdf') {
                type = 'pdf';
            } else if (extension === 'mp4') {
                type = 'video';
            } else if (extension === 'mp3') {
                type = 'audio';
            } else if (extension === 'html') {
                type = 'articulate';
            } else if (extension.includes('blab')) {
                type = 'buildr';
            } else exitPlayer();
        }
        if (!resId) {
            exitPlayer();
        }
        // if (
        //     type == 'buildr' &&
        //     process.env.REACT_APP_INSTALLATION_MODE !== 'webapp'
        // )
        //     return;
        getResourcesById({
            resource_id: resId,
            resource_path: resPath,
            book_uri: bookUri,
            bookId: bookId,
            historyrequired: type === 'ARI',
            type,
        }).then(async (res: any) => {
            if (res?.error) {
                setError(`${res?.error?.data?.error}`);
                return;
            }
            if (res?.data.success) {
                const default_resType = res?.data?.data?.resourceType
                    ? res?.data?.data?.resourceType
                    : type;
                setResType(default_resType);
                let asset_url = res?.data?.data?.url;

                if (default_resType === 'ARI' && asset_url) {
                    // TODO: change the exact attribute as received as part of data payload
                    asset_url = await getARIResourceUrl(
                        asset_url,
                        res?.data?.data?.history,
                        res?.data?.data?.cookie
                    );
                }

                const cookie = res?.data?.data?.cookie || {};
                // if (
                //     !asset_url &&
                //     process.env.REACT_APP_INSTALLATION_MODE === 'webapp' &&
                //     type !== 'buildr'
                // ) {
                //     exitPlayer();
                // }
                if (
                    !asset_url &&
                    process.env.REACT_APP_INSTALLATION_MODE === 'webapp' &&
                    type === 'buildr'
                ) {
                    const localStorageData = JSON.parse(
                        localStorage.getItem('nudgeData') || '{}'
                    );
                    localStorage.setItem(
                        'nudgeData',
                        JSON.stringify({
                            ...localStorageData,
                            buildr_lab_activity_clicked: true,
                        })
                    );
                    const asset_path = resPath
                        .replace('/assets/LAB/', '')
                        .replace('.blab', '');
                    const buildr_base_url =
                        process.env.REACT_APP_BUILDR_LAB_URL || '';
                    asset_url =
                        buildr_base_url +
                        asset_path +
                        `&token=${token}&schoolId=${school_id}`;
                }
                if (asset_url && type === 'buildr')
                    asset_url = asset_url + `&schoolId=${school_id}` + `&ay=${academicYearId}`;

                setCompleteUrl(asset_url);
                setCDNCookies(cookie);
            }
        });
    }, []);

    useEffect(() => {
        if (!isAndroidMediaPlayerOpen) {
            onClose();
        }
        return () => {
            dispatch(setAndroidMediaPlayerOpen(true));
        };
    }, [isAndroidMediaPlayerOpen]);

    if (isError) {
        exitPlayer();
    }

    function exitPlayer() {
        onClose();
        return null;
    }

    const [
        getOpenBrowser,
        { isLoading: isOpenBrowserLoading, isError: isOpenBrowserError },
    ] = useOpenBrowserMutation();
    const handleRedirectionToBrowser = (url: string) => {
        // Trigger the Open Browser mutation
        // const complete_url = process.env.REACT_APP_SIDE_BAR_URL + url;
        if (installationPackage === 'server') {
            window.open(url, '_blank');
            return;
        }
        getOpenBrowser({ url: url })
            .unwrap() // This ensures we get the result of the mutation (or an error)
            .then((response: any) => {
                // Handle successful launch response
                console.log('Open Browser API successful:', response);
            })
            .catch((error: any) => {
                // Handle error
                console.error('Open Browser API failed:', error);
            });
    };
    
    if(completeUrl && process.env.REACT_APP_INSTALLATION_MODE === 'webapp' && type=="articulate"){
        window.open(completeUrl, '_blank');
        exitPlayer();
    }
    

    return (
        <>
            {!completeUrl &&
                !isLoading &&
                process.env.REACT_APP_INSTALLATION_MODE === 'webapp' &&
                resType !== 'buildr' && (
                    <AntdModal
                        title="Coming Soon!"
                        open={isModalOpen}
                        onOk={handleOk}
                        onCancel={handleOk}
                    >
                        <p>
                            This resource is not available yet. Stay tuned for
                            updates!
                        </p>
                    </AntdModal>
                )}
            {!completeUrl &&
                process.env.REACT_APP_INSTALLATION_MODE === 'webapp' &&
                resType === 'buildr' && (
                    <FullScreenModal
                        title={resType}
                        isOpen={isOpen}
                        onClose={() => onClose()}
                        footerButtons={[]}
                    >
                        <PlayerHandler
                            type={resType}
                            resId={resId}
                            bookId={bookId}
                            completeUrl={completeUrl}
                        />
                    </FullScreenModal>
                )}
            {!completeUrl &&
                !isLoading &&
                process.env.REACT_APP_INSTALLATION_MODE !== 'webapp' &&
                resType !== 'buildr' && (
                    <>
                        <AntdModal
                            title={'Available On Online!'}
                            open={isModalOpen}
                            onOk={() => {
                                const redirectUrl = `/resource?id=${resId}`;
                                const finalUrl =
                                    link +
                                    `/login?redirectTo=${encodeURIComponent(redirectUrl)}`;
                                handleRedirectionToBrowser(
                                    finalUrl || 'https://teacher.mybuildr.ai'
                                );
                            }}
                            onCancel={handleOk}
                            okText={'Go online'}
                        >
                            <p>
                                Please connect to the internet and click 'Go
                                online' button below to view this resource.
                            </p>
                        </AntdModal>
                    </>
                )}

            {process.env.REACT_APP_INSTALLATION_MODE !== 'webapp' &&
                resType === 'buildr' && (
                    <AntdModal
                        title={title || ''}
                        open={isPopupOpen}
                        onOk={() => {
                            const redirectUrl = `/resource?id=${resId}`;
                            const finalUrl =
                                link +
                                `/login?redirectTo=${encodeURIComponent(redirectUrl)}`;
                            handleRedirectionToBrowser(
                                finalUrl || 'https://teacher.mybuildr.ai'
                            );
                        }}
                        onCancel={() => {
                            setIsPopupOpen(false);
                            onClose();
                        }}
                        okText={showRedirectButton ? buttonText : ''}
                    >
                        <p>{description}</p>
                    </AntdModal>
                )}
            {(resType === 'video' || resType === 'audio') && completeUrl && (
                <Modal
                    title={resType}
                    isOpen={isOpen}
                    onClose={() => onClose()}
                    footerButtons={[]}
                >
                    <div className="flex flex-col justify-center gap-4">
                        <PlayerHandler
                            type={resType}
                            resId={resId}
                            bookId={bookId}
                            completeUrl={completeUrl}
                        />
                        <h1>{resTitle}</h1>
                    </div>
                </Modal>
            )}
            {(resType === 'articulate' ||
                resType === 'buildr' ||
                resType === 'ARI') &&
                completeUrl && (
                    <FullScreenModal
                        title={resType}
                        isOpen={isOpen}
                        onClose={() => onClose()}
                        footerButtons={[]}
                    >
                        <PlayerHandler
                            type={resType}
                            resId={resId}
                            bookId={bookId}
                            completeUrl={completeUrl}
                        />
                    </FullScreenModal>
                )}
            {/* {resType === 'ARI' && os === 'android' && completeUrl && (
                <PlayerHandler
                    type={resType}
                    resId={resId}
                    bookId={bookId}
                    completeUrl={completeUrl}
                />
            )} */}

            {resType === 'pdf' && completeUrl && (
                <TransparentModal
                    title={resTitle || ''}
                    isOpen={isOpen}
                    completeUrl={completeUrl}
                    onClose={() => onClose()}
                >
                    <div className="flex flex-col justify-center items-center w-full h-auto">
                        <PlayerHandler
                            type={resType}
                            resId={resId}
                            bookId={bookId}
                            completeUrl={completeUrl}
                        />
                    </div>
                </TransparentModal>
            )}
        </>
    );
};

export default React.memo(AssetViewer);
